// Port of api/fuel/app/classes/filter/search/games/filters/query/game/count/threshold.php
export default {
	name: 'game.count.threshold',
	priority: 48,
	require: function(config, filter) { return filter.threshold && filter.threshold.count > 0 },
	run: function(config, filter, data, query) {
		query.where('g.game_players_count', '>=', filter.threshold.count)
	}
}
